import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import StorySection from "@/components/StorySection";
import AppShowcase from "@/components/AppShowcase";
import HowItWorks from "@/components/HowItWorks";
import FeaturesGrid from "@/components/FeaturesGrid";
import PrivacySection from "@/components/PrivacySection";
import PricingSection from "@/components/PricingSection";
import WaitlistHub from "@/components/WaitlistHub";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <>
      <Navbar />
      <main className="min-h-screen bg-background text-foreground overflow-x-hidden">
        <Hero />
        <StorySection />
        <AppShowcase />
        <HowItWorks />
        <FeaturesGrid />
        <PrivacySection />
        <PricingSection />
        <WaitlistHub />
        <Footer />
      </main>
    </>
  );
};

export default Index;
